<div class="p-grid">
  <div class="p-col">
    <p-accordion>
      <p-accordionTab header="{{ 'Rooms' | translate }}" [selected]="true">
        <p-listbox
          [options]="roomsList"
          listStyleClass="kanzi-room-list"
          (onClick)="insert(room.value, 'ROOM')"
          #room
        ></p-listbox>
      </p-accordionTab>
      <p-accordionTab header="{{ 'Doors' | translate }}">
        <div class="p-grid preview-layout">
          <div class="p-col preview-item" *ngFor="let door of doorsList">
            <div (click)="insert(door, 'DOOR')">
              <kanzi-floormap-preview-item
                [type]="'DOOR'"
                [furniture]="door"
              ></kanzi-floormap-preview-item>
              <div class="preview-title">{{ door.title }}</div>
            </div>
          </div>
        </div>
      </p-accordionTab>
      <p-accordionTab header="{{ 'Windows' | translate }}">
        <div class="p-grid preview-layout">
          <div class="p-col preview-item" *ngFor="let wd of windowList">
            <div (click)="insert(wd, 'WINDOW')">
              <kanzi-floormap-preview-item
                [type]="'WINDOW'"
                [furniture]="wd"
              ></kanzi-floormap-preview-item>
              <div class="preview-title">{{ wd.title }}</div>
            </div>
          </div>
        </div>
      </p-accordionTab>
      <p-accordionTab header="{{ 'Furnishings' | translate }}">
        <div class="p-grid preview-layout">
          <div class="p-col preview-item" *ngFor="let Fn of Furniture">
            <div (click)="insert(Fn, 'FURNITURE')">
              <kanzi-floormap-preview-item
                [type]="'FURNITURE'"
                [furniture]="Fn"
              ></kanzi-floormap-preview-item>
              <div class="preview-title">{{ Fn.title }}</div>
            </div>
          </div>
        </div>
      </p-accordionTab>
      <p-accordionTab header="{{ 'Others' | translate }}">
        <div class="p-grid preview-layout">
          <div class="p-col preview-item" *ngFor="let mss of missList">
            <div (click)="insert(mss, 'MISCELLANEOUS')">
              <kanzi-floormap-preview-item
                [type]="'MISCELLANEOUS'"
                [furniture]="mss"
              ></kanzi-floormap-preview-item>
              <div class="preview-title">{{ mss.title }}</div>
            </div>
          </div>
        </div>
      </p-accordionTab>
    </p-accordion>
  </div>
</div>
